/**
 * 标准单对象界面对应的水印配置
 */
export default {
  submit: {
    text: '已提交',
    color: '#e80000'
  },
  back: {
    text: '已退回',
    color: '#979797'
  },
  confirm: {
    text: '已确认',
    color: '#e80000'
  },
  system: {
    text: '系统',
    color: '#e80000'
  },
  void: {
    text: $it('com.voided'),// 已作废
    color: '#e80000'
  },
  execute: {
    text: '已执行',
    color: '#e80000'
  },
  send: {
    text: '已发出',
    color: '#e80000'
  },
  accepet: {
    text: '已验收',
    color: '#e80000'
  },
  checked: {
    text: '已审核',
    color: '#e80000'
  },
  charge: {
    text: '已记账',
    color: '#e80000'
  },
  Inventory: {
    text: $it('tL.bu') , // 已盈亏
    color: '#e80000'
  },
  terminate: {
    text: '已终止',
    color: '#e80000'
  },
  extremely: {
    text: $it('tL.b0'), // 异常终止
    color: '#e80000'
  },
  executing: {
    text: '执行中',
    color: '#e80000'
  },
  completed: {
    text: $it('tL.bn'), // 已完成
    color: '#e80000'
  },
  check: {
    text: '已收银',
    color: '#e80000'
  },
  caseClosed: {
    text: '已中止',
    color: '#e80000'
  },
  out_part_in: {
    text: '出库完成部分入库',
    color: '#e80000',
    width: '60px',
    top: '38px',
    left: '22px'
  },
  part_out_part_in: {
    text: '部分出库部分入库',
    color: '#e80000',
    width: '60px',
    top: '38px',
    left: '22px'
  },
  part_out_not_in: {
    text: '部分出库未入库',
    color: '#e80000',
    width: '60px',
    top: '38px',
    left: '22px'
  },
  part_out: {
    text: '部分出库',
    color: '#e80000'
  },
  part_in: {
    text: '部分入库',
    color: '#e80000'
  },
  out_not_in: {
    text: '出库完成未入库',
    color: '#e80000',
    width: '60px',
    top: '38px',
    left: '22px'
  },
  out_in: {
    text: '出库完成入库完成',
    color: '#e80000',
    width: '60px',
    top: '64px',
    left: '22px'
  },
  out: {
    text: '出库完成',
    color: '#e80000'
  },
  check_not_out: {
    text: '已审核未出库',
    color: '#e80000',
    width: '55px',
    top: '38px',
    left: '25px'
  },
  check_not_enter: {
    text: '已审核未入库',
    color: '#e80000',
    width: '55px',
    top: '38px',
    left: '25px'
  },
  check_not_in: {
    text: '已审核未入库',
    color: '#e80000',
    width: '55px',
    top: '38px',
    left: '25px'
  },
  boxing: {
    text: '装箱中',
    color: '#4bcd61'
  },
  box: {
    text: '已装箱',
    color: '#e80000'
  },
  confirmed_receipt: {
    text: '已确认收货',
    color: '#e80000'
  },
  create: {
    text: '创建',
    color: '#e80000'
  },
  finish_receiptgoods: {
    text: '收货完成',
    color: '#e80000'
  },
  finish_sendgoods: {
    text: '发货完成',
    color: '#e80000'
  },
  no_confirm: {
    text: '未确认',
    color: '#e80000'
  },
  part_receiptgoods: {
    text: '部分收货',
    color: '#e80000'
  },
  part_sendgoods: {
    text: '部分发货',
    color: '#e80000'
  },
  platform_delivery: {
    text: '平台发货',
    color: '#e80000'
  },
  pre_sale_delivery: {
    text: '预售待发货',
    color: '#e80000'
  },
  pre_sale_shortage: {
    text: '预售缺货',
    color: '#e80000'
  },
  preparing: {
    text: '配货中',
    color: '#e80000'
  },
  sale_shortage: {
    text: '缺货',
    color: '#e80000'
  },
  system_cancel: {
    text: '系统作废',
    color: '#e80000'
  },
  trade_finish: {
    text: '交易完成',
    color: '#e80000'
  },
  unfinished: {
    text: '未完结',
    color: '#e80000'
  },
  update: {
    text: '更新',
    color: '#e80000'
  },
  wait_instock: {
    text: '待入库',
    color: '#e80000'
  },
  wait_outstock: {
    text: '待出库',
    color: '#e80000'
  },
  wait_return_warehouse: {
    text: '等待退货入库',
    color: '#e80000',
    width: '60px',
    top: '38px',
    left: '25px'
  },
  wait_saled_audit: {
    text: '等待售后审核',
    color: '#e80000',
    width: '60px',
    top: '38px',
    left: '25px'
  },
  waitBill: {
    text: '待开票',
    color: '#e80000'
  },
  warehouse_delivery: {
    text: '仓库发货',
    color: '#e80000',
  },
  unchecked: {
    text: '未审核',
    color: '#e80000'
  },
  canceled: {
    text: '已取消',
    color: '#e80000'
  },
  systemCancel: {
    text: '系统作废',
    color: '#e80000'
  },
  finish: {
    text: '完成',
    color: '#e80000'
  },
  ended: {
    text: '已完结',
    color: '#e80000'
  },
  finishInstock: {
    text: '入库完成',
    color: '#e80000'
  },
  finishSendgoods: {
    text: '财务发货完成审核中',
    color: '#e80000',
    width: '70px',
    top: '38px',
    left: '17px'
  },
  custAutid: {
    text: '已客审',
    color: '#e80000'
  },
  financeAudit: {
    text: '已财审',
    color: '#e80000'
  },
  delayBill: {
    text: '暂缓开票',
    color: '#e80000'
  },
  finallyBill: {
    text: '已开票',
    color: '#e80000'
  },

  financialAudit: {
    text: '财务审核中',
    color: '#e80000'
  },
  financialMaintain: {
    text: ' 财务维护中',
    color: '#e80000'
  },
  tobeConfirmed: {
    text: '待确认',
    color: '#e80000'
  },
  refuseto: {
    text: '拒回',
    color: '#e80000'
  },
  ProcessCompletion: {
    text: '流程完成',
    color: '#e80000'
  },
  suporting: {
    text: '支持中',
    color: '#e80000'
  },
  leave: {
    text: '已离职',
    color: '#e80000'
  },
  freeze_submit_one: {
    text: '已提交未解冻',
    color: '#e80000'
  },
  freeze_submit_two: {
    text: '已提交部分解冻',
    color: '#e80000'
  },
  freeze_submit_three: {
    text: '全部解冻',
    color: '#e80000'
  },
  audited_not_confirm: {
    text: '已审核未确认',
    color: '#e80000'
  },
  confirm_not_out: {
    text: '已确认未出库',
    color: '#e80000'
  },
  all_submit: {
    text: '全部提交',
    color: '#e80000'
  },
  part_submit: {
    text: '部分提交',
    color: '#e80000'
  },
  submit_confirm: {
    text: '已审核已确认',
    color: '#e80000',
    width: '60px',
    top: '38px',
    left: '22px'
  },
  fallback: {
    text: '回退中',
    color: '#e80000',
  },
  disconnected: {
    text: '已断联',
    color: '#e80000',
  },
  to_be_reviewed: {
    text: '待审核',
    color: '#e80000',
  },
  audit: {
    text: '审核中',
    color: '#e80000',
  },
  search_source: {
    text: '寻源中',
    color: '#e80000',
  },
  await_search_source: {
    text: '待寻源',
    color: '#e80000',
  },
  occupancy_section: {
    text: '部分占单',
    color: '#e80000',
  },
  occupancy_success: {
    text: '占单成功',
    color: '#e80000',
  },
  closed_case: {
    text: '已结案',
    color: '#e80000',
  },
};
